import { useContext } from 'react';

import { LocalOffersLocationContext } from './local-offers-location-context';

export const useLocalOffersLocationContext = () => {
  const context = useContext(LocalOffersLocationContext);

  if (!context) {
    throw new Error('useLocalOffersLocationContext must be used within a LocalOffersLocationProvider');
  }

  return context;
};
